/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentsProvider {
  ECHO = 'ECHO',
  LYNX = 'LYNX',
}
